export function isOccurrenceAllDayOrMultipleDay(occurrence, adapter) {
  if (occurrence.allDay) {
    return true;
  }
  return !adapter.isSameDay(occurrence.displayTimezone.start.value, occurrence.displayTimezone.end.value);
}